export default __webpack_public_path__ + "static/media/empty-folder-1519007-1284948.89601341.png";